import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const StyledAnchor = styled.a`
  display: inline-block;
  font-size: ${fonts.small};
  font-family: var(--font-family-base);
  margin-top: 10px;
  color: ${colours.elexonBlack};
`;

export const StyledText = styled.span`
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledIcon = styled.span`
  font-family: elexon-icons;
  font-size: 10px;
  padding-left: 20px;
`;
